import React, { useEffect, useState } from "react";
import { Input } from "../../../../../shadcn/components/ui/input";
import { Button } from "../../../../../shadcn/components/ui/button";
import { useSelector } from "react-redux";
import { BetaForm as useBetaForm } from "@reusejs/react";
// import { CompanyInfoParser } from "../utils/companyInfoParser";
import {
  fetchFuzzyMatchDetails,
  fetchIDCardDetails,
  // fetchIDCardOCRDetails,
  getBidderByUuid,
  getBusinessVerificationResponse,
  initiateBusinessVerification,
  updateBidderForEvent,
} from "services/bidder";
import CustomModalLayout from "../../../../web/Auth/CustomModalLayout";
// import { Dropdown } from "../../../../../shadcn/components/custom/Dropdown";
// import CustomMultipleFileUploader from "../../../../banker/bidder/CustomMultipleFileUploader";
// type CompanyInfoSources = {
//   udyamData?: any;
//   gstData?: any;
//   cinData?: any;
// };

interface BusinessDetailsComponentProps {
  stepsTitles: any;
  activeStep: any;
  setActiveStep: any;
  bidderUuid: any;
  init: any;
  bidder: any;
}
export default function BusinessDetailsComponent({
  bidderUuid,
  init,
  stepsTitles,
  activeStep,
  setActiveStep,
  bidder,
}: BusinessDetailsComponentProps) {
  const [loading, setLoading] = useState(false);
  const [checkingStatus, setCheckingStatus] = useState(false);
  // const [submissionError, setSubmissionError] = useState(false);
  // const [renderKey, setRenderKey] = useState(0);
  // const [panFiles, setPanFiles] = useState<any>([]);
  // const [panOCRData, setPanOCRData] = useState<any>({});
  const [open, setOpen] = useState(false);
  const [validationErrorModelOpen, setValidationErrorModelOpen] =
    useState(false);
  const [validationErrorModelValue, setValidationErrorModelValue] = useState({
    source_text: "",
    target_text: "",
  });
  // const [validationDetailsModelValue, setValidationDetailsModelValue] =
  //   useState({
  //     isOpen: false,
  //     address_details: "",
  //     incorporation_date: "",
  //     gst_number: "",
  //     business_nature: "",
  //     entity_type: "",
  //     place: "",
  //     data: null,
  //   });
  const [loadingText, setLoadingText] = useState("");
  // const uploaderRef = useRef<any>(null);

  // const types = [
  //   { label: "CIN", value: "CIN" },
  //   { label: "GST", value: "GST" },
  //   { label: "UDYAMAADHAAR", value: "UDYAMAADHAAR" },
  //   // { label: "UAADHAAR", value: "UAADHAAR" },
  //   // { label: "FSSAI", value: "FSSAI" },
  //   // { label: "DIN", value: "DIN" },
  //   // { label: "GST", value: "GST" },
  //   // { label: "TAN", value: "TAN" },
  // ];

  // useEffect(() => {
  //   if (
  //     bidder?.kyc_data?.kyb_request_id &&
  //     bidder?.kyc_data?.status !== "completed"
  //   ) {
  //     fetchAndUpdateBusinessDetails();
  //   }
  // }, [bidder]);

  const onboardingData = useSelector((state: any) => {
    return state.bidderAuth.onboarding;
  });

  // const validationConstraints = {
  //   GST: {
  //     presence: {
  //       allowEmpty: false,
  //     },
  //     format: {
  //       pattern: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
  //       message:
  //         "^Please enter a valid 15-digit GST Number (e.g., 22AAAAA0000A1Z5)",
  //     },
  //   },
  //   CIN: {
  //     presence: {
  //       allowEmpty: false,
  //       message: "^CIN is required",
  //     },
  //     format: {
  //       pattern: /^[LU]{1}[0-9]{5}[A-Z]{2}[0-9]{4}[A-Z]{3}[0-9]{6}$/,
  //       message:
  //         "^Please enter a valid 21-digit Corporate Identification Number (CIN)",
  //     },
  //   },
  //   DIN: {
  //     presence: {
  //       allowEmpty: false,
  //       message: "^DIN is required",
  //     },
  //     format: {
  //       pattern: /^[0-9]{8}$/,
  //       message:
  //         "^Please enter a valid 8-digit Director Identification Number (DIN)",
  //     },
  //   },
  //   TAN: {
  //     presence: {
  //       allowEmpty: false,
  //       message: "^TAN is required",
  //     },
  //     format: {
  //       pattern: /^[A-Z]{4}[0-9]{5}[A-Z]{1}$/,
  //       message: "^Please enter a valid 10-character TAN (e.g., ABCD12345E)",
  //     },
  //   },
  //   UAADHAAR: {
  //     presence: {
  //       allowEmpty: false,
  //       message: "^UAadhaar Number is required",
  //     },
  //     format: {
  //       pattern: /^[2-9]{1}[0-9]{11}$/, // 12-digit starting with 2-9
  //       message:
  //         "^Please enter a valid 12-digit Aadhaar Number (e.g., 234567890123)",
  //     },
  //   },
  //   UDYAMAADHAAR: {
  //     presence: {
  //       allowEmpty: false,
  //       message: "^Udyam Aadhaar Number is required",
  //     },
  //     format: {
  //       pattern: /^UDYAM-[A-Z]{2}-\d{2}-\d{7}$/,
  //       message:
  //         "^Please enter a valid Udyam Aadhaar Number (e.g., UDYAM-TS-02-0042597)",
  //     },
  //   },
  //   FSSAI: {
  //     presence: {
  //       allowEmpty: false,
  //       message: "^FSSAI License Number is required",
  //     },
  //     format: {
  //       pattern: /^[0-9]{14}$/, // 14-digit FSSAI license number
  //       message:
  //         "^Please enter a valid 14-digit FSSAI License Number (e.g., 12345678901234)",
  //     },
  //   },
  // };

  // const form = useBetaForm({
  //   card_number: "",
  //   card_type: "",
  //   is_doc_verified: false,
  // });

  // useEffect(() => {
  //   type DocumentType =
  //     | "GST"
  //     | "CIN"
  //     | "DIN"
  //     | "UAADHAAR"
  //     | "UDYAMAADHAAR"
  //     | "FSSAI";
  //   const selectedType = form.getField("card_type") as { label: DocumentType };
  //   const rules = validationConstraints[selectedType?.label];
  //   form.setValidationRules({
  //     card_type: {
  //       presence: { allowEmpty: false },
  //     },
  //     card_number: rules || {
  //       presence: { allowEmpty: false },
  //     },
  //     pan_uuid: {
  //       presence: {
  //         allowEmpty: false,
  //         message: "^Pan Document is required",
  //       },
  //     },
  //     is_doc_verified: {
  //       presence: {
  //         allowEmpty: false,
  //         message: "^Document must be verified before submitting the form",
  //       },
  //       inclusion: {
  //         within: [true],
  //         message: "^Document must be verified before submitting the form",
  //       },
  //     },
  //   });
  // }, [form.getField("card_type")]);

  // const pollBusinessVerification = async () => {
  //   const interval = 15000; // 15 seconds
  //   let count = 0;

  //   while (true) {
  //     try {
  //       console.log("🔁 Polling Digio business verification...");
  //       const res: any = await getBusinessVerificationResponse({
  //         eligible_bidders_uuid: bidderUuid,
  //       });
  //       count++;
  //       console.log("res: ", res);
  //       if (res?.message === "success") {
  //         return res;
  //       }
  //       if (count === 3) {
  //         setLoadingText(
  //           "Still fetching GST details... This may take a little longer than usual. Please hold on."
  //         );
  //       }
  //     } catch (error) {
  //       console.error("❌ Error during polling:", error);
  //       return;
  //     }
  //     await new Promise((resolve) => setTimeout(resolve, interval));
  //   }
  // };

  // const fetchAndUpdateBusinessDetails = async () => {
  //   try {
  //     setCheckingStatus(true);
  //     setLoadingText("Fetching GST Details. Please wait...");
  //     const res4: any = await pollBusinessVerification();
  //     console.log("res4:---------->>>>", res4);
  //     if (res4?.message === "success") {
  //       const res5: any = await updateBidderForEvent({
  //         uuid: bidderUuid,
  //         verification_step: "add_ar",
  //       });
  //       setLoadingText(
  //         "GST details fetched. Redirecting to the next step. Please wait..."
  //       );
  //       await new Promise((resolve) => setTimeout(resolve, 1000));
  //       setActiveStep(activeStep + 1);
  //       await init();
  //       setCheckingStatus(false);
  //     }
  //   } catch (error) {
  //     // const data: any = await getBidderByUuid(bidderUuid);
  //     // const res5: any = await updateBidderForEvent({
  //     //   uuid: bidderUuid,
  //     //   kyc_data: {
  //     //     ...data?.kyc_data,
  //     //     status: "failed",
  //     //   },
  //     // });
  //     await new Promise((resolve) => setTimeout(resolve, 1000));
  //     await init();
  //     setCheckingStatus(true);
  //     setLoadingText("");
  //   }
  // };
  const gstRegex: RegExp =
    /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/;

  const form = useBetaForm({
    gst: onboardingData.gst || "",
  });

  const form_constraints = {
    gst: {
      presence: {
        allowEmpty: false,
        message: "^Please enter GST number",
      },
      format: {
        pattern: gstRegex,
        message: "^Invalid GST number",
      },
    },
  };

  useEffect(() => {
    form.setValidationRules(form_constraints);
  }, [form?.value?.gst]);

  const handleSubmit = async () => {
    setLoading(true);
    setOpen(false);
    // setSubmissionError(false);
    // console.log("form.validate", form.validate(), form);
    if (form.validate()) {
      try {
        setLoadingText("Fetching GST Details. Please wait...");
        // const payload = {
        //   card_type: form.getField("card_type").value,
        //   card_number: form.getField("card_number"),
        // };
        const payload = {
          card_type: "GST",
          card_number: form.getField("gst"),
        };
        console.log("payload:======>>> ", payload);
        const res: any = await fetchIDCardDetails(payload);
        console.log("res:---- ", res);

        // const type = form.getField("card_type").value;
        // const validTypes: Record<string, keyof CompanyInfoSources> = {
        //   CIN: "cinData",
        //   GST: "gstData",
        //   UDYAMAADHAAR: "udyamData",
        // };

        // const key = validTypes[type];
        // if (!key) throw new Error("Data not found or unsupported card_type");
        // const parser = new CompanyInfoParser({ [key]: res });
        // const fuzzyMatchPayload: any = {
        //   context: "name",
        //   target_text: onboardingData?.name,
        // };
        // console.log("card_type===>>>", form.getField("card_type").value);
        // fuzzyMatchPayload["source_text"] =
        //   form.getField("card_type").value === "CIN"
        //     ? res?.company_data?.company_name
        //     : form.getField("card_type").value === "GST"
        //     ? res?.corporate_name
        //     : form.getField("card_type").value === "UDYAMAADHAAR"
        //     ? res["Name of Enterprise"]
        //     : "";
        // if (!fuzzyMatchPayload["source_text"])
        //   throw new Error("Data not found");
        const fuzzyMatchPayload = {
          context: "name",
          source_text: res?.corporate_name,
          target_text: onboardingData?.name,
        };

        console.log("fuzzyMatchPayload: ", fuzzyMatchPayload);
        const res2: any = await fetchFuzzyMatchDetails(fuzzyMatchPayload);
        console.log("res2: ", res2);
        // const res2: any = {
        //   matched: true,
        //   match_score: 100,
        // };
        if (!res2?.matched) {
          // setValidationErrorModelValue({
          //   source_text: fuzzyMatchPayload["source_text"],
          //   target_text: onboardingData?.name,
          // });
          // setValidationErrorModelOpen(true);
          // setLoading(false);
          // setOpen(false);
          setValidationErrorModelValue({
            source_text: res?.corporate_name,
            target_text: onboardingData?.name,
          });
          setValidationErrorModelOpen(true);
          setLoading(false);
          setLoadingText("");
          return;
        }

        // setValidationDetailsModelValue({
        //   isOpen: true,
        //   address_details: parser.getRegisteredAddress() || "Na",
        //   incorporation_date: parser.getDateOfIncorporation() || "Na",
        //   gst_number: parser.getGSTIN() || "Na",
        //   business_nature: parser.getBusinessNature() || "Na",
        //   entity_type: parser.getEntityType() || "Na",
        //   place: parser.getRegisteredPlace() || "Na",
        //   data: res,
        // });
        const data: any = await getBidderByUuid(bidderUuid);
        console.log("data: ", "data");
        const res5: any = await updateBidderForEvent({
          uuid: bidderUuid,
          meta: {
            ...data?.meta,
            bid_application_flow_mode: "online",
            steps_status: {
              ...data?.meta?.steps_status,
              business_details: "completed",
            },
          },
          kyc_data: {
            gst_data: res,
            status: "completed",
            approval_status: "approved",
            verification_status: "approved",
            action_by: "system",
          },
          kyc_verified: true,
          verification_step: "add_ar",
        });
        await new Promise((resolve) => setTimeout(resolve, 1000));
        setActiveStep(activeStep + 1);
        await init();
        setLoadingText("");
        setLoading(false);
        setOpen(false);

        // console.log("getDateOfIncorporation", parser.getDateOfIncorporation());
        //3 details needed
        //1. Adress of comy with city name etc
        //2.incorporation_date
        //3. business_nature
        //4. gst_number
        // U67100TG2021PTC155434 TAN
        // CIN U70200TG2021PTC155434
        // DIN Director Identification Numbers (DINs)
        // 36AAVCA8648J1ZT GST
        //   setValidationErrorModelOpen(true);
        //   setLoading(false);
        //   setLoadingText("");
        //   return;
        // }
      } catch (error) {
        console.log("error: ", error);
        // const data: any = await getBidderByUuid(bidderUuid);
        // const res5: any = await updateBidderForEvent({
        //   uuid: bidderUuid,
        //   kyc_data: {
        //     ...data?.kyc_data,
        //     status: "failed",
        //   },
        // });
        // await new Promise((resolve) => setTimeout(resolve, 1000));
        // await init();
        // setLoading(false);
        // setLoadingText("");
        // setSubmissionError(true);
        const data: any = await getBidderByUuid(bidderUuid);
        const res5: any = await updateBidderForEvent({
          uuid: bidderUuid,
          kyc_data: {
            ...data?.kyc_data,
            status: "failed",
          },
        });
        await new Promise((resolve) => setTimeout(resolve, 1000));
        await init();
        setLoading(false);
        setLoadingText("");
      }
    }
    setLoading(false);
    setLoadingText("");
  };

  // const handleConfirm = async (responseData: any) => {
  //   setLoading(true);
  //   setLoadingText("Saving the data. Please wait...");
  //   // const businessVerificationPayload = {
  //   //   bidder_onboarding_uuid: onboardingData?.uuid,
  //   //   eligible_bidders_uuid: bidderUuid,
  //   //   // pan_number: onboardingData?.pan,
  //   //   gst_number: form.getField("gst"),
  //   // };
  //   // const res3: any = await initiateBusinessVerification(
  //   //   businessVerificationPayload
  //   // );
  //   // await fetchAndUpdateBusinessDetails();
  //   const data: any = await getBidderByUuid(bidderUuid);
  //   const res5: any = await updateBidderForEvent({
  //     uuid: bidderUuid,
  //     kyc_data: {
  //       business_info: responseData,
  //       document_details: {
  //         document_type: form.getField("card_type"),
  //         document_value: form.getField("card_number"),
  //         address_details: validationDetailsModelValue.address_details,
  //         incorporation_date: validationDetailsModelValue.incorporation_date,
  //         gst_number: validationDetailsModelValue.gst_number,
  //         business_nature: validationDetailsModelValue.business_nature,
  //         entity_type: validationDetailsModelValue.entity_type,
  //         place: validationDetailsModelValue.place,
  //         pan_file: panFiles,
  //       },
  //       // pan_ocr_data: panOCRData,
  //       status: "completed",
  //     },
  //     verification_step: "add_ar",
  //   });
  //   await new Promise((resolve) => setTimeout(resolve, 1000));
  //   setActiveStep(activeStep + 1);
  //   await init();
  //   setLoadingText("");
  //   setLoading(false);
  // };

  // const handleDocumentChange = async (data: any) => {
  //   console.log("id", data?.[0]?.id);
  //   console.log("data: ", data);

  //   if (data?.[0]?.id) {
  //     setLoading(true);
  //     setLoadingText("Validating PAN. Please wait..");
  //     form.removeError("is_doc_verified");
  //     form.setField("is_doc_verified", false);
  //     let res: any = null;
  //     let attempt = 0;
  //     let success = false;
  //     while (attempt < 3 && !success) {
  //       try {
  //         res = await fetchIDCardOCRDetails({
  //           enable_both_sides: false,
  //           check_id_match: false,
  //           front_part: data?.[0]?.id,
  //         });
  //         console.log(`Attempt ${attempt + 1}:`, res);
  //         if (res?.detections?.length) {
  //           setPanOCRData(res?.detections[0]);
  //           success = true;
  //           form.removeError("is_doc_verified");
  //         }
  //       } catch (error: any) {
  //         console.log(`Error on attempt ${attempt + 1}:`, error);
  //         if (error?.response?.status === 400) {
  //           const message: any = error?.response?.data?.errorMessage;
  //           form.setErrors({ is_doc_verified: [message] });
  //           attempt = 4;
  //         }
  //         attempt++;
  //         if (attempt < 3) {
  //           setLoadingText(
  //             "This is taking longer than expected. Please wait a moment..."
  //           );
  //           await new Promise((resolve) => setTimeout(resolve, 18000));
  //         } else if (attempt === 3) {
  //           const message: any = error?.response?.data?.errorMessage;
  //           form.setErrors({ is_doc_verified: [message] });
  //         }
  //       }
  //     }
  //     if (!success) {
  //       await uploaderRef.current?.deleteFile(data?.[0]?.id);
  //       form.setField("is_doc_verified", false);
  //       setLoading(false);
  //       return;
  //     } else {
  //       if (res?.detections?.length > 0) {
  //         const detection = res.detections[0];
  //         if (detection.id_type !== "PAN") {
  //           form.setErrors({
  //             is_doc_verified: [
  //               "Please upload a valid PAN document for your user type.",
  //             ],
  //           });
  //         }
  //         if (detection?.detected_part !== "FRONT") {
  //           form.setErrors({
  //             is_doc_verified: [
  //               "Upload a valid FRONT side of your PAN document to continue.",
  //             ],
  //           });
  //         }
  //         const fuzzyMatchPayload: any = {
  //           context: "name",
  //           target_text: onboardingData?.name,
  //         };
  //         fuzzyMatchPayload["source_text"] =
  //           detection?.id_attributes?.name || "";
  //         const res2: any = await fetchFuzzyMatchDetails(fuzzyMatchPayload);
  //         if (!res2?.matched) {
  //           setValidationErrorModelValue({
  //             source_text: fuzzyMatchPayload["source_text"],
  //             target_text: onboardingData?.name,
  //           });
  //           setValidationErrorModelOpen(true);
  //           setLoading(false);
  //           setOpen(false);
  //           await uploaderRef.current?.deleteFile(data?.[0]?.id);
  //         } else {
  //           form.setField("is_doc_verified", true);
  //         }
  //       }
  //     }
  //     // Success logic here
  //     form.setField("pan_uuid", data?.[0]?.id || "");
  //     setLoadingText("");
  //     setPanFiles(data);
  //     setLoading(false);
  //   }
  // };

  return (
    <div>
      <h4 className="font-bold text-lg font-openSans">
        {stepsTitles?.[activeStep]?.label}
      </h4>
      <div className="mt-4 min-h-[300px]">
        <div className="text-xs md:text-sm font-openSans text-brand-textGrey">
          Please Enter GST number and fetch the details based on your gst number
        </div>
        {/* <div className="text-xs md:text-sm font-openSans text-brand-textGrey mb-4">
          Select a document type to fetch details based on your number.
        </div> */}
        {/* <div>
          <Dropdown
            // disabled={!form.getField("user_can_update")}
            dataSource={() => {
              return Promise.resolve(types);
            }}
            defaultSelected={
              form.getField("card_type") !== ""
                ? form.getField("card_type")
                : null
            }
            selectIdentifier={true}
            onChange={async (value: any) => {
              form.setField("card_type", value);
              form.setField("card_number", "");
            }}
            valueKey="value"
            placeholder="Select Document Type*"
            styles={{
              hideDot: true,
              dropdownItemsClass: "text-brand-borderGrey",
              hoverBgColor: "focus:bg-brand-lightPink",
              hoverTextColor: "focus:text-brand-borderGrey",
              outerContainer:
                "border-[1px] border-brand-borderLightGray rounded-sm text-sm leading-normal font-sans text-brand-texBlack px-4 h-[38px] w-full max-w-xl",
            }}
          />
          {form.errors.get("card_type") ? (
            <p className="mt-1 text-sm text-red-500">
              {form.errors.get("card_type")[0]}
            </p>
          ) : null}
        </div>
        <div className="mt-4">
          <Input
            disabled={loading || open}
            className="border-[1px] border-brand-borderLightGray w-full max-w-xl py-2 px-4 text-sm tracking-wide font-sans text-brand-textBlack rounded"
            placeholder={`Enter ${
              form.getField("card_type")?.value || "Document"
            } number*`}
            value={form.getField("card_number")}
            onChange={(e: any) => {
              const upperValue = e?.target?.value?.toUpperCase();
              form.setField("card_number", upperValue);
            }}
          />
          {form.errors.get("card_number") ? (
            <p className="mt-1 text-sm text-red-500">
              {form.errors.get("card_number")[0]}
            </p>
          ) : null}
        </div> */}
        <div className="mt-4">
          <Input
            disabled={loading || open}
            className="border-[1px] border-brand-borderLightGray w-full max-w-xl py-2 px-4 text-sm tracking-wide font-sans text-brand-textBlack rounded"
            placeholder="Enter GST number*"
            value={form.getField("gst")}
            onChange={(e: any) => {
              form.setField("gst", e?.target?.value);
            }}
          />
          {form.errors.get("gst") ? (
            <p className="mt-1 text-sm text-red-500">
              {form.errors.get("gst")[0]}
            </p>
          ) : null}
        </div>
        {/* <div className="mt-4 max-w-xl">
          <CustomMultipleFileUploader
            key={renderKey}
            handleChange={handleDocumentChange}
            allowedMimeTypes={["image/png", "image/jpeg"]}
            property_uuid={bidderUuid}
            owner_service_type="ni_pan"
            data={panFiles}
            maxAllowed={1}
            defaultText="Please upload Pan*"
            ref={uploaderRef}
          />
          {form.getField("is_doc_verified") === true && (
            <p className="mt-1 text-sm text-green-500">
              Document is verified successfully.
            </p>
          )}
          {form.errors.get("pan_uuid") ? (
            <p className="mt-1 text-sm text-red-500">
              {form.errors.get("pan_uuid")[0]}
            </p>
          ) : form.errors.get("is_doc_verified") ? (
            <p className="mt-1 text-sm text-red-500">
              {form.errors.get("is_doc_verified")[0]}
            </p>
          ) : null}
        </div> */}
        <div className="mt-12">
          <Button
            // disabled={
            //   loading || form.getField("is_doc_verified") != true || open
            // }
            disabled={loading || open}
            className="w-full max-w-xl h-10 text-[18px]"
            onClick={handleSubmit}
          >
            Submit
          </Button>
          {/* {submissionError && (
            <p className="mt-1 text-sm text-red-500">
              Failed to fetch details. Try again later.
            </p>
          )} */}
        </div>
      </div>
      {loading && <LoadingModal loadingText={loadingText} />}
      {/* {checkingStatus && <LoadingModal loadingText={loadingText} />} */}
      <ErrorModel open={open} setOpen={setOpen} handleSubmit={handleSubmit} />
      <ValidationErrorModel
        open={validationErrorModelOpen}
        setOpen={setValidationErrorModelOpen}
        form={form}
        source_text={validationErrorModelValue?.source_text}
        target_text={validationErrorModelValue?.target_text}
      />
      {/* <ValidationDetailsModel
        form={form}
        handleSubmit={handleConfirm}
        loading={loading}
        open={validationDetailsModelValue.isOpen}
        setOpen={() => {
          setValidationDetailsModelValue({
            isOpen: false,
            address_details: "",
            incorporation_date: "",
            gst_number: "",
            business_nature: "",
            entity_type: "",
            place: "",
            data: null,
          });
        }}
        business_info={validationDetailsModelValue.data}
        address_details={validationDetailsModelValue.address_details}
        incorporation_date={validationDetailsModelValue.incorporation_date}
        gst_number={validationDetailsModelValue.gst_number}
        business_nature={validationDetailsModelValue.business_nature}
        entity_type={validationDetailsModelValue.entity_type}
      /> */}
    </div>
  );
}
interface LoadingModalProps {
  loadingText?: string;
}

const LoadingModal = ({ loadingText }: LoadingModalProps) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className=" text-white flex flex-col relative">
        <div className="flex flex-col flex-grow h-full">
          <div className="flex justify-center items-center">
            <div className="w-12 h-12 border-8 border-t-6 border-brand-orange rounded-full animate-spin bg-gradient-to-r from-brand-orange to-blue-100 shadow-lg"></div>
          </div>
          <div className="mt-2 text-sm font-openSans text-center">
            {loadingText || "Validating Details. Please wait"}
          </div>
        </div>
      </div>
    </div>
  );
};

interface ErrorModelProps {
  open: any;
  setOpen: any;
  handleSubmit: any;
}

const ErrorModel = ({ open, setOpen, handleSubmit }: ErrorModelProps) => {
  return (
    <CustomModalLayout
      open={open}
      onClose={() => setOpen(false)}
      childrenClassName="pb-6 px-6 lg:px-8 overflow-y-scroll"
      className="pt-8 lg:pb-[30px] mx-4 w-full md:w-[420px] max-h-[calc(100%-10px)]"
    >
      <div className="flex flex-col justify-between min-h-[243px]">
        <div className="flex flex-col gap-4">
          <h2 className="font-semibold text-lg text-brand-textBlack text-center">
            Action Required
          </h2>
          <p className="text-sm text-brand-orange text-center">
            We encountered an unexpected error while retrieving your business
            details. This may have occurred because the process took longer than
            expected. Please try again.
          </p>
        </div>
        <Button className="mt-6" onClick={handleSubmit}>
          Retry Verification
        </Button>
      </div>
    </CustomModalLayout>
  );
};

interface ValidationErrorModelProps {
  open: any;
  setOpen: any;
  source_text: string;
  target_text: string;
  form: any;
}

const ValidationErrorModel = ({
  open,
  setOpen,
  source_text,
  target_text,
  form,
}: ValidationErrorModelProps) => {
  const handleValidationErrorSubmit = async () => {
    // form.setField("card_number", "");
    form.setField("gst", "");
    setOpen(false);
  };
  return (
    <CustomModalLayout
      open={open}
      onClose={() => {
        // form.setField("card_number", "");
        // setOpen(false);
        form.setField("gst", "");
        setOpen(false);
      }}
      childrenClassName="pb-6 px-6 lg:px-8 overflow-y-scroll"
      className="pt-8 lg:pb-[30px] mx-4 w-full md:w-[420px] max-h-[calc(100%-10px)]"
    >
      <div className="flex flex-col justify-between min-h-[243px]">
        <div className="flex flex-col gap-4">
          <h2 className="font-semibold text-lg text-brand-textBlack text-center">
            Action Required
          </h2>
          <p className="text-sm text-brand-textBlack text-center leading-5 tracking-wide">
            Name validation failed. Our records show the name on your document
            is <strong className="text-brand-orange">{source_text}</strong>, but
            it was verified as <strong>{target_text}</strong>. Please contact
            the Auction Bazaar support team for assistance.
          </p>
        </div>

        <div className="flex flex-col items-center gap-1 mt-4">
          <span className="text-xs text-brand-textBlack">
            Entered incorrect details?
          </span>
          <span
            className="text-xs text-primary underline cursor-pointer font-medium"
            onClick={handleValidationErrorSubmit}
          >
            Discard and Retry
          </span>
        </div>

        {/* <Button className="mt-6" onClick={handleValidationErrorSubmit}>
          Continue
        </Button> */}
      </div>
    </CustomModalLayout>
  );
};

// interface ValidationDetailsModelProps {
//   open: any;
//   loading: boolean;
//   setOpen: any;
//   address_details: string;
//   incorporation_date: string;
//   form: any;
//   gst_number: any;
//   business_nature: any;
//   entity_type: any;
//   handleSubmit: any;
//   business_info: any;
// }

// const ValidationDetailsModel = ({
//   open,
//   loading = true,
//   setOpen,
//   address_details,
//   incorporation_date,
//   form,
//   gst_number,
//   business_nature,
//   entity_type,
//   handleSubmit,
//   business_info = {},
// }: ValidationDetailsModelProps) => {
//   const handleValidationErrorSubmit = async () => {
//     form.setField("card_number", "");
//     setOpen();
//   };

//   return (
//     <CustomModalLayout
//       open={open}
//       onClose={() => {
//         form.setField("card_number", "");
//         setOpen();
//       }}
//       childrenClassName="pb-6 px-4 lg:px-4 overflow-y-scroll"
//       className="pt-8 lg:pb-[30px] mx-4 w-full md:w-[420px] max-h-[calc(100%-10px)]"
//     >
//       <div className="flex flex-col justify-between min-h-[243px]">
//         <div className="flex flex-col gap-2">
//           <h2 className="font-semibold text-lg text-brand-textBlack text-center">
//             Verify Details
//           </h2>

//           <p className="text-xs font-openSans text-brand-textBlack text-center">
//             Please review the company details below. If anything looks
//             incorrect, discard and try again using a different document.
//             <br />
//             Need help? Contact our support team.
//           </p>

//           <div className="space-y-2 text-xs text-brand-textBlack mt-2">
//             <DetailItem label="Address" value={address_details} />
//             <DetailItem label="Incorporation Date" value={incorporation_date} />
//             <DetailItem label="GST Number" value={gst_number} />
//             <DetailItem label="Nature of Business" value={business_nature} />
//             <DetailItem label="Entity Type" value={entity_type} />
//           </div>
//         </div>

//         <div className="flex flex-col items-center gap-1 mt-14">
//           <div className="w-full flex flex-col gap-2">
//             <Button
//               disabled={loading}
//               className="w-full h-9 text-sm"
//               onClick={async () => {
//                 console.log("handleSubmit");
//                 await handleSubmit(business_info);
//               }}
//             >
//               Continue
//             </Button>
//             <div>
//               <p className="text-xs text-center text-brand-textBlack mt-1">
//                 Fetched incorrect details?
//               </p>
//               <Button
//                 className="w-full h-9 text-sm"
//                 variant="outline"
//                 onClick={handleValidationErrorSubmit}
//                 disabled={loading}
//               >
//                 Discard and Retry
//               </Button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </CustomModalLayout>
//   );
// };

// const DetailItem = ({
//   label,
//   value,
// }: {
//   label: string;
//   value: string | number;
// }) => (
//   <div className="flex justify-between items-start gap-2">
//     <span className="font-medium">{label}:</span>
//     <span className="text-right break-words lowercase">{value}</span>
//   </div>
// );
